import {
  InvitationRateLimitState,
  InvitationSendResponse,
  Workspace,
  WorkspaceInput,
  WorkspaceUsers,
} from '../mainApi';
import { ApiClientService } from './ApiClientService';

export class WorkspacesService {
  static async getAll(): Promise<Workspace[]> {
    return ApiClientService.getJson<Workspace[]>(`${ApiClientService.getApiBaseUrl()}/workspaces`);
  }

  static async create(input: WorkspaceInput): Promise<Workspace> {
    return ApiClientService.postJson<Workspace>(
      `${ApiClientService.getApiBaseUrl()}/workspaces`,
      input
    );
  }

  static async update(workspaceId: string, input: WorkspaceInput): Promise<Workspace> {
    return ApiClientService.putJson<Workspace>(
      `${ApiClientService.getApiBaseUrl()}/workspaces/${workspaceId}`,
      input
    );
  }

  static async remove(workspaceId: string, withSpaces: boolean): Promise<void> {
    if (withSpaces) {
      await ApiClientService.deleteJson(
        `${ApiClientService.getApiBaseUrl()}/workspaces/${workspaceId}/topics`
      );
      await ApiClientService.deleteJson(
        `${ApiClientService.getApiBaseUrl()}/workspaces/${workspaceId}/walls`
      );
      await ApiClientService.deleteJson(
        `${ApiClientService.getApiBaseUrl()}/workspaces/${workspaceId}/collages`
      );
    }

    await ApiClientService.deleteJson(
      `${ApiClientService.getApiBaseUrl()}/workspaces/${workspaceId}`
    );
  }

  static async getUsers(workspaceId: string): Promise<WorkspaceUsers> {
    return ApiClientService.getJson<WorkspaceUsers>(
      `${ApiClientService.getApiBaseUrl()}/workspaces/${workspaceId}/users`
    );
  }

  static async invite(
    workspaceId: string,
    emailAddresses: string,
    emailMessage: string
  ): Promise<InvitationSendResponse> {
    return ApiClientService.postJson<InvitationSendResponse>(
      `${ApiClientService.getApiBaseUrl()}/workspaces/invite/${workspaceId}`,
      {
        emailAddresses,
        emailMessage,
      }
    );
  }

  static async getInvitationRateLimit(): Promise<InvitationRateLimitState> {
    return ApiClientService.getJson<InvitationRateLimitState>(
      `${ApiClientService.getApiBaseUrl()}/email-invitations/rate-limit`
    );
  }

  static async removeUser(workspaceId: string, userId: string): Promise<void> {
    await ApiClientService.deleteJson<void>(
      `${ApiClientService.getApiBaseUrl()}/workspaces/${workspaceId}/users/${userId}`
    );
  }
}
